/** FldOnlyBlockSlot — Forklift driver picker + Temp-set Y/N.
 *  Extracted verbatim from QATab.jsx. */
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Field } from "../_shared";
import { useSlotLabel } from "../hooks/useSlotLabels";

export default function FldOnlyBlockSlot({ values, set, ctx }) {
  const { flds = [], visibility } = ctx;
  const lbl = useSlotLabel("qa.fld-only");
  // Temp-set belongs with the Temperatures slot — hide it when that slot is off.
  const showTempSet = visibility ? visibility.slotVisible("qa.temperatures") : true;
  return (
    <div className="pt-2 border-t">
      <h4 className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-2">
        {lbl("section_title", "FLD-only entry")}
      </h4>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <Field label={lbl("fld_assignment", "Forklift driver assignment")}>
          <Select value={values.forklift_driver_user_id || "_none_"}
                  onValueChange={(v) => set("forklift_driver_user_id", v === "_none_" ? "" : v)}>
            <SelectTrigger data-testid="booking-fld-select">
              <SelectValue placeholder="Unassigned" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="_none_">Unassigned</SelectItem>
              {flds.map((u) => (
                <SelectItem key={u.user_id} value={u.user_id}>
                  {[u.first_name, u.last_name].filter(Boolean).join(" ") || u.email}
                  {u.email ? ` · ${u.email}` : ""}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </Field>
        {showTempSet && (
        <Field label={lbl("temp_set", "Temp set (at load)?")}>
          <div className="flex gap-4 text-sm pt-1.5">
            <label className="inline-flex items-center gap-1.5 cursor-pointer">
              <input type="radio" name="temp-set-confirmed"
                     checked={values.temp_set_confirmed === true}
                     onChange={() => set("temp_set_confirmed", true)}
                     data-testid="temp-set-confirmed-yes" />
              <span>Yes</span>
            </label>
            <label className="inline-flex items-center gap-1.5 cursor-pointer">
              <input type="radio" name="temp-set-confirmed"
                     checked={values.temp_set_confirmed === false}
                     onChange={() => set("temp_set_confirmed", false)}
                     data-testid="temp-set-confirmed-no" />
              <span>No</span>
            </label>
          </div>
        </Field>
        )}
      </div>
    </div>
  );
}
